export enum FacilityStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  Suspended = 3,
  Closed = 4,
}

export enum EntityStatus {
  Active = 1,
  Inactive = 0,
  Deleted = -1,
}

export enum AmenityEnum {
  Parking = 1,
  Restrooms = 2,
  Showers = 3,
  Lockers = 4,
  WiFi = 5,
  MedicalServices = 6,
  Cafeteria = 7,
}

export enum UserRole {
  Admin = 1,
  FacilityOwner = 2,
  FacilityManager = 3,
  EventOrganizer = 4,
  EventManager = 5,
  User = 6,
}

export enum bookingStatusEnum {
  Reserved = 0,
  Pending = 1,
  Confirmed = 2,
  Cancelled = 3,
  Completed = 4,
}

export enum CourtStatus {
  Active = 0,
  UnderMaintenance = 1,
  OutOfService = 2,
  Suspended = 3,
}

export enum AttachmentType {
  Image = 1,
  Document = 2,
  Video = 3,
  Audio = 4,
  Other = 5,
}

export enum EntityType {
  Facility,
  Sport,
  User,
  Event,
}

export enum AttachmentStatus {
  Active = 1,
  Processing = 2,
  Failed = 3,
  Deleted = 4,
}

export enum SlotStatus {
  Available,
  Reserved,
  Booked,
}

export enum EventStatus {
  Draft,
  Open,
  InProgress,
  Completed,
  Cancelled,
}

export enum TournamentType {
  Singles,
  Doubles,
  MixedDoubles,
  Team,
}

export enum TournamentTypeString {
  Singles = 'Singles',
  Doubles = 'Doubles',
  MixedDoubles = 'MixedDoubles',
  Team = 'Team',
}

export enum TournamentStatus {
  Draft,
  RegistrationOpen,
  RegistrationClosed,
  BracketGenerated,
  InProgress,
  Completed,
  Cancelled,
}

export enum TournamentTypeKeys {
  Singles = 'Singles',
  Doubles = 'Doubles',
  MixedDoubles = 'Mixed Doubles',
  Team = 'Team',
}

export enum TournamentGender {
  Male,
  Female,
  Mixed,
}

export enum TournamentFormatEnum {
  SingleElimination,
  DoubleElimination,
  RoundRobin,
  GroupStage,
  Custom,
}

export enum ParticipantSide {
  Participant1 = 1,
  Participant2 = 2,
}

export enum SlotCategoryEnum {
  Morning = 'Morning (6 AM - 12 PM)',
  Afternoon = 'Afternoon (12 PM - 5 PM)',
  Evening = 'Evening (5 PM - 8 PM)',
  Night = 'Night (8 PM - 12 AM)',
  Midnight = 'Midnight (12 AM - 6 AM)',
}

export enum PaymentType {
  Booking,
  EventRegistration,
}

export enum PaymentStatus {
  Pending,
  Processing,
  Completed,
  Failed,
  Refunded,
  Cancelled,
  PartiallyRefunded,
}

export enum PaymentMethod {
  CreditCard,
  DebitCard,
  UPI,
  NetBanking,
  Wallet,
  Cash,
}

export enum PaymentLineItemType {
  EventRegistration,
  TournamentEntry,
  BookingSlot,
}

export enum PaymentLineItemStatus {
  Pending,
  Completed,
  Failed,
  Cancelled,
  RefundPending,
  Refunded,
}
